import React, { useState, useEffect } from "react";
import { MdMoveToInbox } from "react-icons/md";
import { RiDeleteBin7Fill } from "react-icons/ri";
import { IoIosInformationCircle } from "react-icons/io";
import { CiSearch } from "react-icons/ci";
import { FaStar } from "react-icons/fa6";
import api from "../../services/Api";

const Inbox = () => {
  const [emails, setEmails] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [starredItems, setStarredItems] = useState({});

  useEffect(() => {
    fetchEmails();
  }, []);

  const fetchEmails = async () => {
    try {
      const response = await api.get("/emails");
      console.log("API Response:", response.data);
      setEmails(response.data.email);
    } catch (error) {
      console.error("Error fetching emails:", error);
    }
  };

  const handleCheckboxChange = (index) => {
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [index]: !prevCheckedItems[index],
    }));
  };

  const handleStarClick = (index) => {
    setStarredItems((prevStarredItems) => ({
      ...prevStarredItems,
      [index]: !prevStarredItems[index],
    }));
  };

  return (
    <div className="py-4 bg-white mx-4">
      <div className="flex items-center justify-between px-4 mb-4">
        <div className="relative">
          <input
            type="text"
            placeholder="Search mail"
            className="w-full px-10 py-2 font-sans text-xs border rounded-2xl bg-[#F5F6FA]"
          />
          <CiSearch className="absolute top-1/2 left-4 transform -translate-y-1/2 text-gray-500" />
        </div>

        <div className="flex border p-2 rounded-lg gap-4">
          <button>
            <MdMoveToInbox />
          </button>
          <button>
            <IoIosInformationCircle />
          </button>
          <button>
            <RiDeleteBin7Fill />
          </button>
        </div>
      </div>

      <div className="bg-white shadow-md rounded overflow-hidden">
        <table className="min-w-full text-[#202224] text-xs">
          <tbody>
            {Array.isArray(emails) && emails.map((email, index) => (
              <tr
                key={index}
                className={`border-b accent-black ${
                  checkedItems[index] ? "bg-[#F4F7FF]" : "hover:bg-gray-100"
                }`}
              >
                <td className="px-4 py-2">
                  <input
                    type="checkbox"
                    checked={!!checkedItems[index]}
                    onChange={() => handleCheckboxChange(index)}
                  />
                </td>
                <td className="px-4 py-2">
                  <FaStar
                    onClick={() => handleStarClick(index)}
                    className={`cursor-pointer ${
                      starredItems[index] ? "text-yellow-500" : "text-gray-200"
                    }`}
                  />
                </td>
                <td className="px-4 py-2">{email.sender}</td>
                <td className="px-4 py-2">{email.subject}</td>
                <td className="px-4 py-2">{email.time}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Inbox;
